import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { REQUEST_TYPES } from 'src/app/core/models/enum.model';
import { UserRequest } from 'src/app/core/models/userRequest.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { UserRequestService } from 'src/app/core/services/userRequest.service';

@Component({
  selector: 'app-insert-request',
  templateUrl: './insert-request.component.html',
  styleUrls: ['./insert-request.component.scss']
})
export class InsertRequestComponent implements OnInit {
  userRequest = new UserRequest();
  requestTypes = REQUEST_TYPES;
  insertUserRequest: FormGroup;

  constructor(private alertService: AlertService,
    private userRequestService: UserRequestService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    private router: Router) { }

  ngOnInit(): void {
    this.insertUserRequest = this.formBuilder.group({
      requestType: new FormControl(null, [
        Validators.required
      ]),
      title: new FormControl(null, [
        Validators.maxLength(100),
        Validators.required
      ]),
      message: new FormControl(null, [
        Validators.maxLength(1000),
        Validators.required
      ])
    });
  }

  save() {
    if (this.insertUserRequest.invalid) {
      this.alertService.alert('Hata', 'Lütfen formdaki alanları eksiksiz tamamlayınız!', 'error')
      return;
    }
    if (this.insertUserRequest.valid) {
      this.loadingService.setLoading(true);
      let data = Object.assign({}, this.insertUserRequest.value);

      this.userRequest.requestType = data.requestType;
      this.userRequest.title = data.title;
      this.userRequest.message = data.message;


      this.userRequestService.createUserRequest(this.userRequest).subscribe(response => {
        if (response.success) {
          this.alertService.alert('Başarılı!', 'Destek talebiniz eklendi!', 'success')
          this.router.navigate(['/my-requests']);
        }
        this.loadingService.setLoading(false);
      }, (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      })

    }
  }

  get f() {
    return this.insertUserRequest.controls;
  }

}
